module.exports = __webpack_public_path__ + "static/media/shop-online-bg.61017704.png";